module.exports = __webpack_public_path__ + "epdf-app/dashboard/batch/modal-reject-batch-102-2uyBN1Aa.html";